import { render, staticRenderFns } from "./IncomeStatic.vue?vue&type=template&id=b07f07e0&scoped=true"
import script from "./IncomeStatic.vue?vue&type=script&lang=js"
export * from "./IncomeStatic.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatic.vue?vue&type=style&index=0&id=b07f07e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07f07e0",
  null
  
)

export default component.exports